import { render, staticRenderFns } from "./Ordering.vue?vue&type=template&id=7af7dfe2&scoped=true"
import script from "./Ordering.vue?vue&type=script&lang=js"
export * from "./Ordering.vue?vue&type=script&lang=js"
import style0 from "./Ordering.vue?vue&type=style&index=0&id=7af7dfe2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af7dfe2",
  null
  
)

export default component.exports